import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Flag } from '../../api';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { setVisibilityOfCustomerChat } from '../../states/app/app.actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  public static readonly baseUrl = 'api/public';

  constructor(
    private http: HttpClient,
    private store: Store,
  ) {}

  public loadFeatureFlags(): void {
    this.http
      .get<Flag>(`${FeatureService.baseUrl}/features/customerChatEnabled`)
      .pipe(
        untilDestroyed(this),
        map((flag) => {
          this.store.dispatch(setVisibilityOfCustomerChat({ showCustomerChat: flag.enabled }));
        }),
      )
      .subscribe();
  }
}
